import React from "react";
import pfp from "../img/pfp.jpg";

const AboutSection = () => {
    return (
        <section
            id="about"
            className="bg-gray-950 text-white py-16 px-6 md:px-12 lg:px-20"
        >
            <div className="max-w-6xl mx-auto flex flex-col-reverse md:flex-row items-center md:items-start space-y-12 md:space-y-0 md:space-x-12 animate-fade-in">
                {/* Profile Picture */}
                <div className="flex-shrink-0 w-48 mt-[14px] h-48 md:w-64 md:h-64 lg:w-72 lg:h-72 rounded-full overflow-hidden shadow-xl transform hover:scale-105 transition duration-500">
                    <img
                        src={pfp}
                        alt="Bheesham Kumar"
                        className="w-full h-full object-cover"
                    />
                </div>

                {/* About Content */}
                <div className="text-center md:text-left px-4 md:px-0">
                    <h2 className="text-3xl md:text-4xl font-bold mb-6">
                        About Me <span className="text-teal-400">| Bheesham Kumar</span>
                    </h2>
                    <p className="text-gray-400 text-base md:text-lg mb-8">
                        I am a passionate <span className="text-teal-400">Frontend Developer</span> with 1 year of learning experience. I have honed my skills in creating responsive and interactive web applications using modern frontend technologies.
                    </p>

                    {/* Skills */}
                    <div>
                        <h3 className="text-xl md:text-2xl font-semibold text-teal-400 mb-4">
                            My Expertise:
                        </h3>
                        <ul className="list-disc list-inside space-y-3 text-gray-400">
                            <li>HTML, CSS, and JavaScript</li>
                            <li>Frameworks: Tailwind CSS, Bootstrap</li>
                            <li>Libraries: React.js</li>
                            <li>Backend Integration: Firebase</li>
                            <li>Strong foundation in Frontend Development concepts</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
